export default __webpack_public_path__ + "static/media/borb.55d866e2.jpg";